import { useField } from 'formik'

import countries from 'Fixtures/countries'

import Heading from 'components/Heading'
import Button from 'components/Button'

import { TextField, SelectField } from 'components/Fields'

import styles from '../Signup.module.css'

import RightArrow from 'public/icons/rightarrow.svg'

const ChooseRegion = ({ setValue, handleSubmit, formField, isSubmitting }) => {
  const { country, postalCode } = formField

  const submit = () => {
    setValue('step', 'region')
    handleSubmit()
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        {`Let's Build Your Profile`}
        <br />
        {`Where are you located?`}
      </Heading>
      <div className={styles['choose-region-wrapper']}>
        <div className={styles['country-wrapper']}>
          <SelectField name={country.name} placeholder={country.label} options={countries} />
        </div>

        <TextField name={postalCode.name} label={postalCode.label} className={styles['signup-input']} />

        <div className={styles['form-footer']}>
          <Button onClick={submit} primary centered disabled={isSubmitting} spinner={isSubmitting}>
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChooseRegion
